import { useCallback, useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { useNavigate } from 'react-router-dom';
import { deleteOffer, getOfferList } from 'app/api/offer';
import { isOfferExpired } from './CreateOffer/useCreateOffer';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import Message from 'app/utils/Message';
import { ParseTableLabelDate } from 'app/utils/Parsers';
import Toast from 'app/utils/Toast';
const useOfferDeal = () => {
  const sectionObj = {
    sectionTitle: 'Offer Management',
    searchObj: {
      keys: ['title', 'mallName', 'storeName'],
      placeholder: 'Search by Title, Mall name, Store Name',
      searchType: 'server',

      handleSearch: (e) => {
        console.log('Handle search: ', e);
      },
    },
    buttons: [
      {
        customclassName: '',
        imgTrue: true,
        title: APP_CONSTANTS.CREATE_OFFER_TAG,
        handleBtnClick: (e) => {
          navigate(`${APP_CONSTANTS.CREATE_OFFER_DEALS}`);
        },
      },
    ],
  };
  const [isdeleteFiltering, setIsdeleteFiltering] = useState(false); // New state to track filtering
  const navigate = useNavigate();
  const [pageCount, setPageCount] = useState(1);
  const [pageLoading, setPageLoading] = useState(false);
  const currentPage = 1;
  const dataPerPage = 10;
  const [filteredData, setFilteredData] = useState([]);

  const [totalNumber, setTotalNumber] = useState(0);

  const fetchOfferData = useCallback(
    async (page, searchValue = '') => {
      console.log('page', page);
      setPageLoading(true);
      try {
        const response = await getOfferList({
          page,
          limit: dataPerPage,
          search: searchValue,
        });
        if (response?.responseCode === 200) {
          const dataArr = response?.data?.offersData || [];
          const newArray = dataArr.map((item) => {
            // An offer past its end date is shown as Inactive in the list even
            // if it is still toggled on in the database.
            const expired = isOfferExpired(item?.endDate);
            return {
              ...item,
              status: expired ? false : item.status,
              toggle: expired ? false : item.status, // Add new key here
              mallName: item?.mallId?.mallName,
              storeName: item?.storeId?.storeName,
              startDate: ParseTableLabelDate(item?.startDate),
              endDate: ParseTableLabelDate(item?.endDate),
            };
          });
          setFilteredData(newArray);
          const totalCount = response?.data?.count || 0;
          setTotalNumber(totalCount);
          const tempcount = Math.ceil(totalCount / dataPerPage);
          setPageCount(tempcount);
          setIsdeleteFiltering(false);
        } else {
          Toast.error(
            response?.response?.message || Message.Error.COMMON_MESSAGE
          );
        }
      } catch (error) {
        Toast.error(Message.Error.COMMON_MESSAGE);
      } finally {
        setPageLoading(false);
      }
    },
    [dataPerPage]
  );

  async function calldeleteOffer(data) {
    setPageLoading(true);
    if (data && data?.id) {
      let responseObj = await deleteOffer(data?.id);
      setPageLoading(false);
      if (responseObj?.responseCode === 200) {
        setIsdeleteFiltering(true);
        Toast.success('Offer Deleted Successfully');
      } else {
        Toast.error(
          responseObj?.response?.message
            ? responseObj?.response?.message
            : Message.Error.COMMON_MESSAGE
        );
      }
    } else {
      Toast.error('Failed to delete');
    }
  }

  function handleDelete(data) {
    confirmAlert({
      title: '',
      message: `Are you sure you want to Delete  this Offer?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            //  setToggled(!toggled);
            calldeleteOffer(data);
          },
        },
        {
          label: 'No',
        },
      ],
      overlayClassName: 'overlay-custom-class-name',
    });
  }
  function handleEdit(data) {
    navigate(`/offer-deals/edit/:${data.id}`, {
      state: {
        ...data,
      },
    });
  }

  // useEffect(() => {
  //   setIsdeleteFiltering(false)
  // }, [])
  // useEffect(() => {
  //   if (isdeleteFiltering) {
  //     handleDelete();
  //     setIsdeleteFiltering(false);
  //   }
  // }, [isdeleteFiltering]);

  return {
    handleDelete,
    pageLoading,
    currentPage,
    dataPerPage,
    pageCount,
    navigate,
    handleEdit,
    totalNumber,
    filteredData,
    sectionObj,
    fetchOfferData,
    isdeleteFiltering,
  };
};
export default useOfferDeal;
